var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircle96(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0003 25.0834C7.87917 25.0834 2.91699 20.1212 2.91699 14C2.91699 7.87886 7.87917 2.91669 14.0003 2.91669C20.1215 2.91669 25.0837 7.87886 25.0837 14C25.0837 16.9395 23.916 19.7586 21.8374 21.8371C19.7589 23.9156 16.9398 25.0834 14.0003 25.0834ZM14.0003 3.50002C8.20133 3.50002 3.50033 8.20103 3.50033 14C3.50033 19.799 8.20133 24.5 14.0003 24.5C19.7993 24.5 24.5003 19.799 24.5003 14C24.5003 8.20103 19.7993 3.50002 14.0003 3.50002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.709 18.9584H14.2923V19.5417H13.709V18.9584ZM13.709 8.45837V17.5H14.2923V8.45837H13.709Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle96);
export default __webpack_public_path__ + "static/media/exclamation-circle_96.7fc09d23c56c488792155cbced2dfc08.svg";
export { ForwardRef as ReactComponent };